import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProfileTypes, UserType } from '@api/Users/User';
import { BranchOffice } from '@api/BranchOffices/BranchOffice';
import { DistributionCenter } from '@api/DistributionCenters/DistributionCenter';

export interface AuthState {
    loggedUser?: UserType;
    profileSelected?: ProfileTypes;
    branchOfficeSelected?: BranchOffice;
    distributionCenterSelected?: DistributionCenter;
}

const initialState: AuthState = {
    loggedUser: undefined,
    profileSelected: undefined,
    branchOfficeSelected: undefined,
    distributionCenterSelected: undefined
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoggedUser: (state, action: PayloadAction<UserType>) => {
            state.loggedUser = action.payload;
        },
        setProfileSelected: (state, action: PayloadAction<ProfileTypes>) => {
            state.profileSelected = action.payload;
        },
        setBranchOfficeSelected: (state, action: PayloadAction<BranchOffice | undefined>) => {
            state.branchOfficeSelected = action.payload;
        },
        setDistributionCenterSelected: (state, action: PayloadAction<DistributionCenter | undefined>) => {
            state.distributionCenterSelected = action.payload;
        },
        resetLoggedUser: (state) => {
            state.loggedUser = undefined;
            state.profileSelected = undefined;
            state.branchOfficeSelected = undefined;
            state.distributionCenterSelected = undefined;
        }
    }
});

export const {
    setLoggedUser,
    setProfileSelected,
    setBranchOfficeSelected,
    setDistributionCenterSelected,
    resetLoggedUser
} = authSlice.actions;

export default authSlice.reducer;
